import {connect} from "react-redux";
import React, {useEffect} from "react";

const ShapesGoogleModelViewer = (props) => {
  const {cabinetsGlb, isMobile} = props;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js";
    script.type = "module";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!cabinetsGlb) {
    return null
  }

  return <div className={"sqft-ar"}>
    <model-viewer id="model-viewer"
                  src={cabinetsGlb}
                  //src="/images/sqft-icons/3d/Chair.glb"
                  ar=""
                  //exposure="1"
                  camera-controls=""
                  camera-orbit="45deg 55deg 4m"
                  style={{position:"absolute", width: "100%", height: isMobile ? "100%" : `calc(100% - 80px)`}}
                  alt=""
    >
    </model-viewer>
  </div>
}

const mapStateToProps = (store) => ({
  isMobile: store.serverState.isMobile,
  cabinetsGlb: store.sqftState.cabinetsGlb,
});

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(ShapesGoogleModelViewer);
